import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import MenuItem from './menuItem';
import MenuTree from './menuTree';

class Menu extends Component {
  state = {
    menu: []
  };

  componentDidMount(props) {
    this.setState({ menu: this.props.menu });
  }

  render() {
    return this.state.menu.map((item, index) => {
      if (isEmpty(item.tree)) {
        return <MenuItem key={index} path={item.path} icon={item.icon} label={item.label} />;
      }
      return (
        <MenuTree key={index} icon={item.icon} label={item.label}>
          {item.tree.map((treeItem, treeIndex) => {
            if (isEmpty(treeItem.tree)) {
              return (
                <MenuItem
                  key={treeIndex}
                  path={treeItem.path}
                  label={treeItem.label}
                  icon={treeItem.icon}
                  tree
                />
              );
            }
            return (
              <MenuTree key={treeIndex} icon={treeItem.icon} label={treeItem.label}>
                {treeItem.tree.map((subItem, subIndex) => {
                  return (
                    <MenuItem
                      key={subIndex}
                      path={subItem.path}
                      label={subItem.label}
                      icon={subItem.icon}
                    />
                  );
                })}
              </MenuTree>
            );
          })}
        </MenuTree>
      );
    });
  }
}

const mapStateToProps = () => ({});
const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Menu);
